


// import React, { useState, useEffect, useRef } from 'react';
// import axios from 'axios';
// import { FaEdit, FaTrash, FaPlus } from 'react-icons/fa';
// import ProjectModal from './ProjectModal';
// import { useParams, useNavigate } from 'react-router-dom';
// import { Link } from 'react-router-dom';
// import { useSearchParams } from 'react-router-dom';
// import ReactPaginate from 'react-paginate';
// import withPermission from '../../utils/withPermission';
// import Swal from 'sweetalert2';


// const ProjectList = ({ parentId, clientId }) => {
//     const [projects, setProjects] = useState([]);
//     const [clients, setClients] = useState([]);
//     const [showModal, setShowModal] = useState(false);
//     const [selectedProjectId, setSelectedProjectId] = useState(null);
//     const [selectedProjectData, setSelectedProjectData] = useState(null);
//     const [errors, setErrors] = useState({});
//     const didFetchRef = useRef(false);
//     const navigate = useNavigate();
//     const [searchParams] = useSearchParams();
//     const [currentPage, setCurrentPage] = useState(1);
//     const [pageCount, setPageCount] = useState(1);
//     const { id } = useParams();
//     const [searchQuery, setSearchQuery] = useState('');
//     const debounceTimeoutRef = useRef(null);
//     const WithEditPermission = withPermission(({ children }) => children, [`project-edit`]);
//     const WithCreatePermission = withPermission(({ children }) => children, [`project-create`]);
//     const WithDeletePermission = withPermission(({ children }) => children, [`project-delete`]);
//     // useEffect(() => {
//     //     if (!didFetchRef.current) {

//     //         fetchProjects(currentPage);
//     //         didFetchRef.current = true;
//     //     }
//     // }, [currentPage]);

// useEffect(() => {
//     if (!clientId) {
//         console.log("Waiting for clientId...");
//         return; // Don't fetch projects until clientId is ready
//     }
//         if (debounceTimeoutRef.current) {
//             clearTimeout(debounceTimeoutRef.current);
//         }

//         debounceTimeoutRef.current = setTimeout(() => {
//             fetchProjects(1, searchQuery);
//         }, searchQuery ? 1500 : 0); 

//         return () => {
//             if (debounceTimeoutRef.current) {
//                 clearTimeout(debounceTimeoutRef.current);
//             }
//         };
//     }, [searchQuery,clientId]);
//     const handleSearchChange = (e) => {
//         setSearchQuery(e.target.value);

//     };   

//     const fetchProjects = async (page = 1) => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');

//             const token = userInfo?.token;


//             // Build the correct URL
//             let url = `${backendUrl}/api/projects?client_id=${clientId}`;
//             if (parentId) {
//                 url += `&parent_id=${parentId}`;
//             }


//             const response = await axios.get(url, {
//                 headers: { 'Authorization': `Bearer ${token}` ,
//                 'Tenant-Origin': origin,

//             },
//                 params: { page:page, search: searchQuery },
//             });

//             const projectData = response.data.Data.data || [];
//             setProjects(projectData);

//             const totalPages = response.data.meta ? response.data.meta.total_pages : 1;
//             setPageCount(totalPages);
//             setCurrentPage(page);
//         } catch (error) {
//             console.error('Error fetching projects:', error);
//         }
//     };




//     const fetchClients = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');

//             const token = userInfo?.token;

//             // Fetch all contacts
//             const response = await axios.get(`${backendUrl}/api/contacts`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,

//                 },
//                 skipLoader: true,

//             });

//             const allContacts = response.data.Data; // Assuming the API returns contacts in `Data`
//             setClients(allContacts);
//         } catch (error) {
//             console.error('Error fetching contacts:', error);
//         }
//     };




//     const addProject = async (newProject) => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const isSales = searchParams.get('sales') === 'true';

//             const payload = parentId
//                 ? { ...newProject, parent_id: parentId, issales: isSales }
//                 : { ...newProject, issales: isSales };

//             console.log('Payload being sent to backend:', payload);
//             const response = await axios.post(`${backendUrl}/api/projects`, payload, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Content-Type': 'multipart/form-data',
//                     'Tenant-Origin': origin,

//                 },
//             });

//             const createdProject = response.data.Data;
//             setProjects((prevProjects) => [...prevProjects, createdProject]);

//             handleCloseModal();
//         } catch (error) {
//             if (error.response?.data?.errors) {
//                 return error.response.data.errors; // Return validation errors
//             } else {

//             console.error(`Error adding project`, error);
//             }
//         }
//     };

//     const editProject = async (projectId, updatedData) => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;

//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');

//             const token = userInfo?.token;

//             const response = await axios.post(`${backendUrl}/api/projects/${projectId}?_method=PUT`, updatedData, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Content-Type': 'multipart/form-data',
//                     'Tenant-Origin': origin,


//                 },
//             });

//             const updatedProject = response.data.Data;

//             if (updatedProject) {

//                 setProjects((prevProjects) =>
//                     prevProjects.map((project) =>
//                         project.id === updatedProject.id ? updatedProject : project
//                     )
//                 );
//             } else {
//                 console.error('Update failed, no data returned.');
//             }

//             handleCloseModal();
//         } catch (error) {

//             if (error.response?.data?.errors) {
//                 return error.response.data.errors; // Return validation errors
//             } else {
//                 console.error('Error updating project:', error);
//             }
//         }
//     };

//     const deleteProject = async (clientId) => {
//         Swal.fire({
//             title: "Are you sure?",
//             text: "You won't be able to revert this!",
//             icon: "warning",
//             showCancelButton: true,
//             confirmButtonColor: "#d33",
//             cancelButtonColor: "#3085d6",
//             confirmButtonText: "Yes, delete it!"
//         }).then(async (result) => {
//             if (result.isConfirmed) {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;

//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');

//             const token = userInfo?.token;

//             await axios.delete(` ${backendUrl}/api/projects/${clientId}`, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Tenant-Origin': origin,

//                 },
//             });

//             setProjects(projects.filter(project => project.id !== clientId));
//             Swal.fire(
//                 "Deleted!",
//                 "The project has been deleted.",
//                 "success"
//             );
//         } catch (error) {
//             console.error('Error deleting project:', error);
//             Swal.fire(
//                 "Error!",
//                 "Failed to delete project. Please try again.",
//                 "error"
//             );
//         }
//     }
// });
//     };

//     const handleShowModal = (projectId = null) => {
//         if (projectId) {
//             const projectToEdit = projects.find(project => project.id === projectId);
//             setSelectedProjectData(projectToEdit || null); // Set data for editing
//         } else {
//             setSelectedProjectData(null); // Clear form data for creating new project
//             setErrors({}); // Clear any errors
//         }
//         setSelectedProjectId(projectId);
//         setShowModal(true);
//     };

//     const handleCloseModal = () => {
//         setShowModal(false);
//         setSelectedProjectId(null);
//         setSelectedProjectData(null);
//         setErrors({});
//     };

//     const handlePageChange = ({ selected }) => {
//         const newPage = selected + 1;
//         setCurrentPage(newPage);
//         fetchProjects(newPage);
//     };
//     const isSales = searchParams.get('sales') === 'true';

//     return (

//         <React.Fragment>
//             {/* <h4 className="mb-sm-0 font-size-18">{parentId ? 'Sub Projects' : 'Projects'}</h4> */}
//             <div className="d-flex justify-content-end mb-2">
//                 {/* Search Box */}
//                 <div className="search-box me-2">
//                     <div className="position-relative">
//                         <input
//                             type="text"
//                             className="form-control  font-size-12"
//                             placeholder="Search..."
//                             value={searchQuery}
//                             onChange={handleSearchChange}
//                         />
//                         <i className="bx bx-search-alt search-icon" />
//                     </div>
//                 </div>
//                 {!isSales && (

//                 <WithCreatePermission>
//                 <button
//                                                     type="button"
//                                                     className="btn rounded-circle border d-flex align-items-center justify-content-center round-plus"

//                                                     onClick={() => handleShowModal()}
//                                                     data-bs-toggle="tooltip"
//                                                     data-bs-placement="top"
//                                                     id="tool"
//                                                     title="Add Project"
//                                                 >
//                                                     <i className="mdi mdi-plus" style={{ fontSize: "16px" }}></i>
//                                                 </button></WithCreatePermission>
//                 )}
//                                                 </div>
//        <div className="contacts-table-modern">
//                 <div className="table-responsive">
//                     <table className="table table-modern">
//                         <thead>

//                                     <tr>
//                         <th scope="col">#</th>
//                         <th scope="col">Project ID</th>

//                         <th scope="col">Project Name</th>
//                         <th scope="col">Project Code </th>
//                         <th scope="col">Start Date</th>

//                         <th scope="col">Expected Value</th>

//                         <th scope="col">Actions</th>
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {projects.length > 0 ? (
//                         projects.map((project, index) => (
//                             <tr key={project.id}>
//                                 <td>{index + 1}</td>
//                                 <td><Link to={`/project/details/${project.id}`} className="dropdown-item">
//                                     {project.project_number}
//                                 </Link>
//                                 </td>
//                                 <td><Link to={`/project/details/${project.id}`} className="dropdown-item">
//                                     {project.name}
//                                 </Link>
//                                 </td>
//                                 <td>
//                                     <Link to={`/project/details/${project.id}`} className="dropdown-item">

//                                         {project.code}</Link>
//                                 </td>
//                                 <td>{project.start_date}</td>

//                                 <td>{project.expected_value}</td>
//                                 <td>
//                                     <div className="dropdown">
//                                         <i
//                                             className="mdi mdi-dots-horizontal font-size-18"
//                                             data-bs-toggle="dropdown"
//                                             aria-expanded="false"
//                                             style={{ cursor: 'pointer' }}
//                                         ></i>
//                                         <ul className="dropdown-menu dropdown-menu-end font-size-14">
//                                             <li>
//                                                 <Link to={`/project/details/${project.id}`} className="dropdown-item">
//                                                     View Details
//                                                 </Link>
//                                             </li>
//                                             <li><WithEditPermission>
//                                                 <button
//                                                     className="dropdown-item"
//                                                     onClick={() => handleShowModal(project.id)}
//                                                 >
//                                                     Edit
//                                                 </button></WithEditPermission>
//                                             </li>
//                                             <li><WithDeletePermission>
//                                                 <button
//                                                     className="dropdown-item"
//                                                     onClick={() => deleteProject(project.id)}
//                                                 >
//                                                     Delete
//                                                 </button></WithDeletePermission>
//                                             </li>
//                                             {/* <li>
//                                             <Link
//                                                 to={`/licenses?project_id=${project.id}&client_id=${project.client ? project.client.id : ''}`}
//                                                 className="dropdown-item"
//                                             >
//                                                 License
//                                             </Link>
//                                         </li> */}
//                                         </ul>
//                                     </div>
//                                 </td>
//                             </tr>
//                         ))
//                     ) : (
//                         <tr>
//                             <td colSpan="8">No projects available</td>
//                         </tr>
//                     )}
//                 </tbody>
//             </table>
//             </div></div>

//             <div className="d-flex justify-content-end pagination-sm">
//             <ReactPaginate
//                             previousLabel={'<'}
//                             nextLabel={'>'}
//                             breakLabel={'...'}
//                             pageCount={pageCount}
//                             marginPagesDisplayed={2}
//                             pageRangeDisplayed={3}
//                             onPageChange={handlePageChange}
//                             containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
//                             pageClassName={'page-item'}
//                             pageLinkClassName={'page-link'}
//                             previousClassName={'page-item previous'}
//                             previousLinkClassName={'page-link'}
//                             nextClassName={'page-item next'}
//                             nextLinkClassName={'page-link'}
//                             breakClassName={'page-item'}
//                             breakLinkClassName={'page-link'}
//                             activeClassName={'active'}
//                         />
//             </div>


//             <ProjectModal
//                 showModal={showModal}
//                 handleClose={handleCloseModal}
//                 projectId={selectedProjectId}
//                 projectData={selectedProjectData}
//                 addProject={addProject}
//                 editProject={editProject}
//                 clients={clients}
//                 errors={errors}
//                 setErrors={setErrors}

//                 fetchClients={fetchClients}
//                 defaultClientId={clientId}

//             />
//         </React.Fragment>


//     );
// };

// export default ProjectList;


import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { FaEdit, FaTrash, FaPlus } from 'react-icons/fa';
import ProjectModal from './ProjectModal';
import { useParams, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import withPermission from '../../utils/withPermission';
import Swal from 'sweetalert2';
import { Dropdown } from 'react-bootstrap';


const ProjectList = ({ parentId, clientId, onCloseOffcanvas, onReopenOffcanvas, onOpenProjectDetails }) => {
    const [projects, setProjects] = useState([]);
    const [clients, setClients] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedProjectId, setSelectedProjectId] = useState(null);
    const [selectedProjectData, setSelectedProjectData] = useState(null);
    const [errors, setErrors] = useState({});
    const didFetchRef = useRef(false);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const { id } = useParams();
    const [searchQuery, setSearchQuery] = useState('');
    const debounceTimeoutRef = useRef(null);
    const WithEditPermission = withPermission(({ children }) => children, [`project-edit`]);
    const WithCreatePermission = withPermission(({ children }) => children, [`project-create`]);
    const WithDeletePermission = withPermission(({ children }) => children, [`project-delete`]);

    useEffect(() => {
        if (!clientId) {
            console.log("Waiting for clientId...");
            return;
        }
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }

        debounceTimeoutRef.current = setTimeout(() => {
            fetchProjects(1, searchQuery);
        }, searchQuery ? 1500 : 0);

        return () => {
            if (debounceTimeoutRef.current) {
                clearTimeout(debounceTimeoutRef.current);
            }
        };
    }, [searchQuery, clientId]);

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    const fetchProjects = async (page = 1) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            let url = `${backendUrl}/api/projects?client_id=${clientId}`;
            if (parentId) {
                url += `&parent_id=${parentId}`;
            }

            const response = await axios.get(url, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                params: { page: page, search: searchQuery },
                skipLoader: true,
            });

            const projectData = response.data.Data || [];
            setProjects(projectData);

            // const totalPages = response.data.meta ? response.data.meta.total_pages : 1;
            // setPageCount(totalPages);
            // setCurrentPage(page);
            const pagination = response.data.pagination;
            if (pagination) {
                setPageCount(pagination.total_pages || 1);
                setCurrentPage(pagination.current_page || 1);
            } else {
                // Fallback if old structure
                const totalPages = response.data.meta ? response.data.meta.last_page : 1;
                setPageCount(totalPages);
                setCurrentPage(page);
            }
        } catch (error) {
            console.error('Error fetching projects:', error);
        }
    };

    const fetchClients = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/contacts`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });

            const allContacts = response.data.Data;
            setClients(allContacts);
        } catch (error) {
            console.error('Error fetching contacts:', error);
        }
    };

    const addProject = async (newProject) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const isSales = searchParams.get('sales') === 'true';

            const payload = parentId
                ? { ...newProject, parent_id: parentId, issales: isSales }
                : { ...newProject, issales: isSales };

            console.log('Payload being sent to backend:', payload);
            const response = await axios.post(`${backendUrl}/api/projects`, payload, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                    'Tenant-Origin': origin,
                },
            });

            const createdProject = response.data.Data;
            setProjects((prevProjects) => [...prevProjects, createdProject]);

            handleCloseModal();
        } catch (error) {
            if (error.response?.data?.errors) {
                return error.response.data.errors;
            } else {
                console.error(`Error adding project`, error);
            }
        }
    };

    const editProject = async (projectId, updatedData) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.post(`${backendUrl}/api/projects/${projectId}?_method=PUT`, updatedData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                    'Tenant-Origin': origin,
                },
            });

            const updatedProject = response.data.Data;

            if (updatedProject) {
                setProjects((prevProjects) =>
                    prevProjects.map((project) =>
                        project.id === updatedProject.id ? updatedProject : project
                    )
                );
            } else {
                console.error('Update failed, no data returned.');
            }

            handleCloseModal();
        } catch (error) {
            if (error.response?.data?.errors) {
                return error.response.data.errors;
            } else {
                console.error('Error updating project:', error);
            }
        }
    };

    const deleteProject = async (clientId) => {

        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            await axios.delete(` ${backendUrl}/api/projects/${clientId}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            setProjects(projects.filter(project => project.id !== clientId));
            Swal.fire({
                icon: "success",
                text: "Deleted Successfully.",
                showConfirmButton: false,
                timer: 3000,
                position: 'top-end',
                toast: true,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                }
            });

        } catch (error) {
            console.error('Error deleting project:', error);
        }
    };

    const handleShowModal = (projectId = null) => {
        if (projectId) {
            const projectToEdit = projects.find(project => project.id === projectId);
            setSelectedProjectData(projectToEdit || null);
        } else {
            setSelectedProjectData(null);
            setErrors({});
        }
        setSelectedProjectId(projectId);
        setShowModal(true);

        // Hide the parent offcanvas when modal opens
        // if (onCloseOffcanvas) {
        //     onCloseOffcanvas();
        // }
    };
    const handleOpenProjectDetails = (projectId, projectData) => {
        // First, close the current offcanvas (client details)
        if (onCloseOffcanvas) {
            onCloseOffcanvas();
        }

        // Then open the project details offcanvas
        if (onOpenProjectDetails) {
            onOpenProjectDetails(projectId, projectData);
        }
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedProjectId(null);
        setSelectedProjectData(null);
        setErrors({});

        // Reopen the parent offcanvas when modal closes
        // if (onReopenOffcanvas) {
        //     onReopenOffcanvas();
        // }
    };

    const handlePageChange = ({ selected }) => {
        const newPage = selected + 1;
        setCurrentPage(newPage);
        fetchProjects(newPage);
    };

    const isSales = searchParams.get('sales') === 'true';

    const handleImport = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            console.log('🔍 DEBUG - Import Client ID:', clientId);

            const formData = new FormData();
            formData.append('file', file);

            // Add client_id to the import request if available
            if (clientId && clientId !== 'null' && clientId !== 'undefined') {
                formData.append('client_id', clientId);
                console.log('✅ Added client_id to import form data');
            } else {
                console.log('❌ No client_id available for import');
            }

            console.log('📤 Sending import request...');

            const response = await axios.post(
                `${backendUrl}/api/projects/import`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data',
                        'Tenant-Origin': origin,
                    },
                }
            );

            console.log('✅ Import response:', response.data);

            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: response.data.message || `Projects imported successfully!`,
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
            });

            // Refresh the list after import
            fetchProjects(currentPage);

            // Clear the file input
            event.target.value = '';

        } catch (error) {
            console.error('❌ Import error:', error);
            console.error('❌ Import error response:', error.response);

            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: error.response?.data?.message || `Failed to import projects`,
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
            });
            event.target.value = "";
        }
    };

    // Export Functions
    const handleExport = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            console.log('🔍 DEBUG - Export Client ID:', clientId);
            console.log('🔍 DEBUG - Export Client ID Type:', typeof clientId);

            // Build the export URL
            let exportUrl = `${backendUrl}/api/projects/export`;

            // Only add client_id if it exists and is valid
            if (clientId && clientId !== 'null' && clientId !== 'undefined') {
                exportUrl += `?client_id=${clientId}`;
                console.log('✅ Added client_id to export URL');
            } else {
                console.log('❌ No client_id available for export');
            }

            console.log('🔗 Final Export URL:', exportUrl);

            const response = await axios.get(exportUrl, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                responseType: 'blob',
            });

            // Create blob link and download
            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;

            // Get filename from response headers or use default
            const contentDisposition = response.headers['content-disposition'];
            let filename = `Projects_${new Date().toISOString().split('T')[0]}.xlsx`;

            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
                if (filenameMatch && filenameMatch.length === 2) {
                    filename = filenameMatch[1];
                }
            }

            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

            console.log('✅ Export completed successfully');

            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: `Projects exported successfully!`,
                timer: 2000,
                timerProgressBar: false,
                showConfirmButton: false,
            });

        } catch (error) {
            console.error('❌ Export error:', error);
            console.error('❌ Export error response:', error.response);

            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: `Failed to export projects`,
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
            });
        }
    };
    return (
        <React.Fragment>
            <div className="d-flex justify-content-end mb-2">
                <div className="search-box me-2">
                    <div className="position-relative">
                        <input
                            type="text"
                            className="form-control  font-size-12"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearchChange}
                        />
                        <i className="bx bx-search-alt search-icon" />
                    </div>
                </div>
                <div className="d-flex align-items-center gap-2">
                    {/* Export Button */}
                    <button
                        type="button"
                        className="btn btn-light border"
                        onClick={handleExport}
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Export"
                    >
                        <i className="mdi mdi-file-excel text-success"></i>
                    </button>

                    {/* Import Button */}
                    <input
                        type="file"
                        accept=".xlsx, .xls"
                        id="importLeadsFile"
                        onChange={handleImport}
                        style={{ display: "none" }}
                    />
                    <label
                        htmlFor="importLeadsFile"
                        className="btn btn-light border mb-0"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Import"
                    >
                        <i className="mdi mdi-upload text-primary"></i>
                    </label>

                    {/* Add Button */}

                    {!isSales && (
                        <WithCreatePermission>
                            <button
                                type="button"
                                className="btn rounded-circle border d-flex align-items-center justify-content-center round-plus"
                                onClick={() => handleShowModal()}
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                id="tool"
                                title="Add Project"
                            >
                                <i className="mdi mdi-plus" style={{ fontSize: "16px" }}></i>
                            </button>
                        </WithCreatePermission>
                    )}
                </div>

            </div>

            <div className="contacts-table-modern">
                <div className="table-responsive">
                    <table className="table table-modern">
                        <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Project ID</th>
                                <th scope="col" className="text-start">Project Name</th>
                                <th scope="col">Start Date</th>
                                <th scope="col">Expected Value</th>
                                <th scope="col">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {projects.length > 0 ? (
                                projects.map((project, index) => (
                                    <tr key={project.id}>
                                        <td>{index + 1}</td>
                                        <td>
                                            <button
                                                type="button"
                                                className="btn btn-link p-0 dropdown-item"
                                                onClick={() => handleOpenProjectDetails(project.id, project)}
                                            >
                                                {project.project_number}
                                            </button>
                                        </td>
                                        <td className="text-start">
                                            <button
                                                type="button"
                                                className="btn btn-link p-0 dropdown-item text-start"
                                                onClick={() => handleOpenProjectDetails(project.id, project)}
                                            >
                                                {project.name}
                                            </button>
                                        </td>
                                        <td>{new Date(project.start_date).toLocaleDateString()}</td>
                                        <td>{project.expected_value}</td>
                                        <td>
                                            <Dropdown drop='up'>
                                                <Dropdown.Toggle
                                                    as="span"
                                                    className="border-0 bg-transparent shadow-none"
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    <i className="mdi mdi-dots-horizontal font-size-18"></i>
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu className="font-size-14">
                                                    <Dropdown.Item onClick={() => handleOpenProjectDetails(project.id, project)}>

                                                        View Details
                                                    </Dropdown.Item>
                                                    <WithEditPermission>
                                                        <Dropdown.Item onClick={() => handleShowModal(project.id)}>
                                                            Edit
                                                        </Dropdown.Item>
                                                    </WithEditPermission>
                                                    <WithDeletePermission>
                                                        <Dropdown.Item
                                                            onClick={() => deleteProject(project.id)}
                                                            className="text-danger"
                                                        >
                                                            Delete
                                                        </Dropdown.Item>
                                                    </WithDeletePermission>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="8">No projects available</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="d-flex justify-content-end pagination-sm">
                <ReactPaginate
                    previousLabel={'<'}
                    nextLabel={'>'}
                    breakLabel={'...'}
                    pageCount={pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={3}
                    onPageChange={handlePageChange}
                    containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
                    pageClassName={'page-item'}
                    pageLinkClassName={'page-link'}
                    previousClassName={'page-item previous'}
                    previousLinkClassName={'page-link'}
                    nextClassName={'page-item next'}
                    nextLinkClassName={'page-link'}
                    breakClassName={'page-item'}
                    breakLinkClassName={'page-link'}
                    activeClassName={'active'}
                />
            </div>

            <ProjectModal
                showModal={showModal}
                handleClose={handleCloseModal}
                projectId={selectedProjectId}
                projectData={selectedProjectData}
                addProject={addProject}
                editProject={editProject}
                clients={clients}
                errors={errors}
                setErrors={setErrors}
                fetchClients={fetchClients}
                defaultClientId={clientId}
            />
        </React.Fragment>
    );
};

export default ProjectList;







